/* Tipografia: quebras de linha.
 * O CSS (text-wrap: balance/pretty em critical.css) trata das órfãs.
 * Aqui só se cola com espaço inquebrável o que nunca pode ficar sozinho
 * no fim de uma linha: palavras de uma letra e artigos (a, o, e, é, à, ou,
 * a, an, the, I, &)
 * e números com a unidade (24 €, 20 cm, 12 fatias). Colar palavras
 * maiores (de, para, com...) criava blocos grandes e era a causa das
 * órfãs do tipo "Nuvem / de Morango".
 * Só trata os nós novos ou alterados, não o body inteiro a cada mudança.
 */
(function () {
  'use strict';
  var RE_CURTA = /(^|[\s(\u00A0"“‘])(a|o|e|é|à|ou|an|the|I|&)[ \t]+(?=\S)/gi;
  var RE_UNIDADE = /(\d)[ \t]+(€|cm|kg|g|un\.?|pessoas|people|fatias|slices|h|min)(?=[\s.,;:!?)]|$)/g;
  var PULAR = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, CODE: 1, PRE: 1, NOSCRIPT: 1, OPTION: 1 };

  function colar(t) {
    var antes, v = 0;
    do { antes = t; t = t.replace(RE_CURTA, '$1$2\u00A0'); } while (t !== antes && ++v < 3);
    return t.replace(RE_UNIDADE, '$1\u00A0$2');
  }

  function tratarTexto(n) {
    var p = n.parentNode;
    if (!p || PULAR[p.nodeName] || p.isContentEditable) return;
    var v = n.nodeValue;
    if (!v || v.indexOf(' ') === -1) return;
    var novo = colar(v);
    if (novo !== v) n.nodeValue = novo;
  }

  /* Textos curtos (até 120 caracteres) ficam com text-wrap: balance, que
   * reparte as palavras por igual; a última palavra curta cola à anterior. */
  var BLOCOS = 'p,li,dd,figcaption,blockquote,h1,h2,h3,h4,[class*="__n"],[class*="__s"],[class*="sub"]';
  function ultimaPalavra(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, ult = null;
    while ((n = w.nextNode())) if (/\S/.test(n.nodeValue)) ult = n;
    if (!ult || PULAR[ult.parentNode.nodeName]) return;
    ult.nodeValue = ult.nodeValue.replace(/[ \t]+(\S{1,5}\s*)$/, '\u00A0$1');
  }
  function equilibrar(raiz) {
    var els = raiz.matches && raiz.matches(BLOCOS) ? [raiz] : [];
    if (raiz.querySelectorAll) els = els.concat(Array.prototype.slice.call(raiz.querySelectorAll(BLOCOS)));
    for (var i = 0; i < els.length; i++) {
      var el = els[i], t = el.textContent.trim();
      if (!t || t.indexOf(' ') === -1) continue;
      if (t.length <= 120) el.classList.add('tw-b');
      ultimaPalavra(el);
    }
  }

  function aplicar(raiz) {
    if (!raiz) return;
    if (raiz.nodeType === 3) { tratarTexto(raiz); return; }
    if (raiz.nodeType !== 1 && raiz.nodeType !== 9) return;
    var w = (raiz.ownerDocument || document).createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var lote = [], n;
    while ((n = w.nextNode())) lote.push(n);
    for (var i = 0; i < lote.length; i++) tratarTexto(lote[i]);
    equilibrar(raiz.nodeType === 9 ? raiz.body : raiz);
  }

  var obs = null, fila = [], pendente = false;
  function esvaziar() {
    pendente = false;
    var alvos = fila; fila = [];
    if (obs) obs.disconnect();
    for (var i = 0; i < alvos.length; i++) if (alvos[i].isConnected) aplicar(alvos[i]);
    ligar();
  }
  function ligar() {
    if (!('MutationObserver' in window) || !document.body) return;
    if (!obs) obs = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (r.type === 'characterData') fila.push(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) fila.push(r.addedNodes[j]);
      }
      if (!pendente && fila.length) { pendente = true; (window.requestAnimationFrame || setTimeout)(esvaziar); }
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function arranque() { aplicar(document.body); ligar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranque);
  else arranque();
  window.Tipografia = { aplicar: function (r) { if (obs) obs.disconnect(); aplicar(r || document.body); ligar(); } };
})();

/* Revela logo o que ja esta no viewport e observa o resto. Conteudo nao espera
 * por uma animacao decorativa para ficar legivel. */
(function () {
  'use strict';

  function revelar(el) {
    el.classList.add('is-in');
    el.classList.add('in');
  }

  function iniciarReveals() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!items.length) return;
    document.documentElement.classList.add('io-ready');

    var porRevelar = [];
    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.12 && rect.bottom > -40) revelar(el);
      else porRevelar.push(el);
    });

    if (!porRevelar.length) return;
    if (!('IntersectionObserver' in window)) {
      porRevelar.forEach(revelar);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revelar(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 100px' });
    porRevelar.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarReveals, { once: true });
  else iniciarReveals();
})();
